<template>
  <div class="navbar-item locale-changer">
    <select v-model="$i18n.locale">
      <option v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang">{{
        lang.toLocaleUpperCase()
      }}</option>
    </select>
  </div>
</template>

<script>
export default {
  name: "locale-changer",
  data() {
    return { langs: ["fi", "en"] };
  }
};
</script>

<style lang="scss" scoped></style>
